<template>
<div class="terms-wrapper" data-aos="fade-left">
    <h1 class='terms-title'>Datenschutzerklärung</h1>

    <div class="term">
        <h3 class='terms-subtitle'>1. Verantwortliche Stelle</h3> 

        <p class='terms-sm-text'>
            <b>CleanData ℅ LEVELS AG</b><br>
            St. Galler Str. 5<br> 
            9042 Speicher, Schweiz <br> 
            E-Mail: info@cleandata.ch 
        </p><br>
 
        
        <p class='terms-sm-text'>
            Die LEVELS AG ist verantwortlich für die Verarbeitung personenbezogener Daten im Rahmen des Dienstes CleanData gemäss dem Bundesgesetz über den Datenschutz (DSG) und der Datenschutz-Grundverordnung (DSGVO).
        </p>
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>2. Arten der verarbeiteten Daten</h3>

        <p class='terms-sm-text '>
            <b>Bei der Registrierung:</b>
        </p>
        
        <ul>
            <li>
                <p class='terms-sm-text'>Vorname und Nachname</p>
            </li>
            <li>
                <p class='terms-sm-text'>Geburtsdatum</p>
            </li>
            <li>
                <p class='terms-sm-text'>Adresse, Telefonnummer</p>
            </li>
            <li>
                <p class='terms-sm-text'>E-Mail-Adresse</p>
            </li>
            <li>
                <p class='terms-sm-text'>Passwort</p>
            </li>
        </ul><br> 


        <p class='terms-sm-text '>
            <b>Nach dem Login / bei Erteilung einer Vollmacht:</b>
        </p>
        
        <ul>
            <li>
                <p class='terms-sm-text'>Kopie eines amtlichen Ausweises (Vorder- und Rückseite)</p>
            </li>
            <li>
                <p class='terms-sm-text'>sigitale oder handschriftliche Unterschrift</p>
            </li> 
        </ul><br>


        <p class='terms-sm-text '>
            <b>Während der Nutzung:</b>
        </p>
        
        <ul>
            <li>
                <p class='terms-sm-text'>IP-Adresse, Logfiles, Zeitstempel, Sitzungsdaten</p>
            </li>
            <li>
                <p class='terms-sm-text'>Supportkommunikation und interne Protokolle</p>
            </li> 
        </ul>
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>3. Zweck der Verarbeitung</h3>
        

        <ul>
            <li>
                <p class='terms-sm-text'>Bereitstellung und Betrieb des CleanData-Dienstes</p>
            </li>
            <li>
                <p class='terms-sm-text'>Durchführung von Auskunfts- und Löschungsbegehren im Auftrag des Nutzers</p>
            </li>
            <li>
                <p class='terms-sm-text'>Authentifizierung und Identitätsprüfung</p>
            </li>
            <li>
                <p class='terms-sm-text'>Nachweis der rechtmässigen Bevollmächtigung</p>
            </li>
            <li>
                <p class='terms-sm-text'>Kundenkommunikation und Support</p>
            </li>
            <li>
                <p class='terms-sm-text'>Vertragserfüllung, Fakturierung</p>
            </li>
             <li>
                <p class='terms-sm-text'>Sicherheit, Stabilität und Missbrauchsvermeidung</p>
            </li>
             <li>
                <p class='terms-sm-text'>Versand freiwilliger Newsletter (sofern eingewilligt)</p>
            </li>
        </ul><br>

        <p class='terms-sm-text '>
            CleanData handelt als beauftragter Vertreter des Nutzers. Die Verantwortung für die Rechtmässigkeit der Begehren verbleibt beim Nutzer.
        </p>
    </div>
 

    <div class="term">
        <h3 class='terms-subtitle'>4. Rechtsgrundlagen</h3>

        <ul>
            <li>
                <p class='terms-sm-text'>Art. 31 Abs. 2 lit. a DSG / Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</p>
            </li>
            <li>
                <p class='terms-sm-text'>Art. 6 Abs. 1 lit. c DSGVO (rechtliche Verpflichtung)</p>
            </li>
            <li>
                <p class='terms-sm-text'>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Sicherheit und Nachweisbarkeit)</p>
            </li>
            <li>
                <p class='terms-sm-text'>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung, z. B. Newsletter)</p>
            </li> 
        </ul>
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>5. Datenweitergabe</h3>

        <p class='terms-sm-text '>Personenbezogene Daten werden nur weitergegeben, soweit dies zur Vertragserfüllung erforderlich ist:</p>

        <ul>
            <li>
                <p class='terms-sm-text'>an datenverarbeitende Unternehmen, bei denen Datenschutzbegehren gestellt werden,</p>
            </li>
            <li>
                <p class='terms-sm-text'>an Hosting-, E-Mail- oder Zahlungsdienstleister (z. B. Payrexx, Hostpoint, ggf. Google Workspace).</p>
            </li> 
        </ul><br>

        <p class='terms-sm-text'>
            Der E-Mail-Versand erfolgt derzeit über <b>Hostpoint (Schweiz).</b><br>  
            Zukünftig kann der Versand über <b>Google Workspace (Irland/USA)</b> erfolgen; in diesem Fall werden die EU-Standardvertragsklauseln angewendet.<br>
            Alle internen Mitarbeitenden und technischen Dienstleister mit Zugriff auf Personendaten sind vertraglich zur Vertraulichkeit verpflichtet.
        </p>
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>6. Serverstandort und Datensicherheit</h3>

        <p class='terms-sm-text'>Alle Produktivdaten werden auf Servern in der Schweiz gespeichert.</p><br>

        <p class='terms-sm-text'>
            Datenübertragungen erfolgen ausschliesslich über verschlüsselte Verbindungen (TLS/SSL).<br> 
            Der Zugriff auf sensible Daten ist auf autorisierte Systemnutzer beschränkt.<br>
            Die LEVELS AG arbeitet fortlaufend daran, zusätzliche Verschlüsselungsverfahren (z. B. AES-256 für gespeicherte Daten) zu implementieren.
        </p> 
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>7. Speicherdauer</h3>

        <p class='terms-sm-text'>Daten werden nur so lange gespeichert, wie sie für die Vertragserfüllung notwendig sind oder gesetzliche Pflichten bestehen.</p><br>

        <p class='terms-sm-text'>
            Identifikationsdaten (Ausweis, Unterschrift) werden während eines aktiven Abonnements gespeichert, da sie für wiederholte Anfragen benötigt werden.<br>
            Nach Vertragsende werden sie spätestens nach 30 Tagen gelöscht oder anonymisiert.
        </p><br>  

        <p class='terms-sm-text'>Backups werden nach Ablauf der Speicherdauer nur passiv aufbewahrt und in den regulären Überschreibungszyklen gelöscht.</p>
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>8. Rechte der betroffenen Personen</h3>

        <p class='terms-sm-text'>Nutzer haben das Recht auf:</p>

        <ul>
            <li>
                <p class='terms-sm-text'>Auskunft</p>
            </li>
            <li>
                <p class='terms-sm-text'>Berichtigung</p>
            </li> 
             <li>
                <p class='terms-sm-text'>Löschung (nach Vertragsende)</p>
            </li> 
             <li>
                <p class='terms-sm-text'>Einschränkung der Verarbeitung</p>
            </li> 
             <li>
                <p class='terms-sm-text'>Datenübertragbarkeit</p>
            </li> 
        </ul><br>

        <p class='terms-sm-text'>
            Anfragen sind an <b>datenschutz@cleandata.ch</b> zu richten.<br>
            Während eines aktiven Abonnements besteht kein Anspruch auf Löschung der Identifikationsdaten, da diese für wiederkehrende Begehren zwingend erforderlich sind.
        </p> 
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>9. Cookies und Tracking</h3>

        <p class='terms-sm-text'>
            CleanData verwendet Cookies und ähnliche Technologien, um die Funktionalität und Sicherheit der Plattform zu gewährleisten.<br>
            Optional können anonyme Nutzungsanalysen (z. B. Matomo oder Google Analytics) eingesetzt werden. In diesem Fall werden keine personenbezogenen Profile erstellt, und Nutzer können der Analyse jederzeit widersprechen
        </p> 
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>10. Newsletter</h3>

        <p class='terms-sm-text'>
            Nutzer können freiwillig den CleanData-Newsletter abonnieren.<br>
            Die Anmeldung erfolgt durch separate Checkbox und Double-Opt-in-Verfahren.<br>
            Abmeldung ist jederzeit über den Link im Newsletter möglich.
        </p> 
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>11. Änderungen dieser Datenschutzerklärung</h3>

        <p class='terms-sm-text'>
            Der Anbieter kann diese Datenschutzerklärung jederzeit anpassen.<br>
            Die jeweils aktuelle Version ist auf <b>www.cleandata.ch/datenschutz</b> abrufbar.<br>
            Massgeblich ist die zum Zeitpunkt der Nutzung gültige Fassung.
        </p> 
    </div>

    <div class="term">
        <h3 class='terms-subtitle'>12. Datenschutzanfragen und Datenschutzkoordination</h3>

        <p class='terms-sm-text'>Für Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an:</p><br>

        <p class='terms-sm-text'>
            <b>Datenschutzkoordination CleanData</b><br>
            LEVELS AG<br>
            St. Galler Str. 5<br>
            9042 Speicher, Schweiz<br>
            E-Mail: <b>datenschutz@cleandata.ch</b>
        </p><br>
         

        <p class='terms-sm-text'>Die LEVELS AG hat eine interne Datenschutzkoordination benannt, die für die Umsetzung der Datenschutzmassnahmen und den Umgang mit Anfragen verantwortlich ist.</p>
    </div>
</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.terms-wrapper {
    padding: 20px 0;
    width: 80%;
    margin: 0 auto;
}

.terms-title {
    margin: 0;
    margin-bottom: 40px;
    font-size: 64px;
    font-weight: bold;
    color: #000000;
}

.terms-subtitle {
    font-size: 20px;
    color: #000000;
    margin-bottom: 10px;
}

.terms-sm-text {
    font-size: 18px;
    margin-bottom: 10px;    
    color: #666666; 
}

.black {
    color: #000000;
}

 

.highlight-text {
    color: #FF3A67;
}

ul {
    font-size: 18px;
    color: #666666;
    margin-left: 35px;

    p {
        margin: 0 !important;
    }
}

.term {
    margin-bottom: 40px;

    &:last-child{
        margin: 0;
    }
}

.date{
    margin-top: 30px;
}

/* imac retina */
/*2560-1440*/
@media (min-width: 2560px) {
    .terms-title {
        font-size: 66px;
    }

    .terms-subtitle {
        font-size: 26px;
    }

    .terms-sm-text {
        font-size: 24px;
    }

    ul {
        font-size: 24px;
    }
}

/*2573-1206*/
@media(min-width: 2573px) {}

/* 2880-1670 */
@media(min-width: 2880px) {}

/* 3000-1870 */
@media(min-width: 3000px) {
    .terms-title {
        font-size: 68px;
    }

    .terms-subtitle {
        font-size: 28px;
    }

    .terms-sm-text {
        font-size: 26px;
    }

    ul {
        font-size: 26px;
    }
}

/*3200-1800*/
@media(min-width: 3200px) {}

/*3360-1890 1695*/
@media(min-width:3360px) {
    .terms-title {
        font-size: 70px;
    }

    .terms-subtitle {
        font-size: 30px;
    }

    .terms-sm-text {
        font-size: 28px;
    }

    ul {
        font-size: 28px;
    }
}

/* 3840 x 2160 2049 (4K) */
@media(min-width:3840px) {
    .terms-title {
        font-size: 74px;
    }

    .terms-subtitle {
        font-size: 34px;
    }

    .terms-sm-text {
        font-size: 32px;
    }

    ul {
        font-size: 32px;
    }
}

/* 1920x961 (current) */

/* macbook pro 16 2021 */
/*1728x1085*/
@media(max-width: 1728px) {
    .terms-wrapper { 
        width: 85%;
    }  

    .terms-title { 
        font-size: 60px;
    }
}

/*1688-1080*/
@media(max-width: 1688px) {}

/*1680-1080*/
@media(max-width: 1680px) {}

/*1640-1080*/
@media(max-width: 1640px) { 
    .terms-title { 
        font-size: 58px;
    }

    .terms-subtitle {
        font-size: 18px; 
    }

    .terms-sm-text {
        font-size: 16px; 
    }

    ul {
        font-size: 16px; 

        p {
            margin: 0 !important;
        }
    } 
}

/* 1600 - 757 */
@media (max-width: 1600px) {
    .terms-title { 
        font-size: 56px;
    }
}

/*1536-864*/
@media(max-width:1536px) {
    .terms-title { 
        font-size: 54px;
    }
}

/* macbook pro/air */
/* 1440-900 */
@media(max-width:1440px) {
    .terms-title { 
        font-size: 52px;
    }
}

/*1366-638*/
@media (max-width:1366px) {
    .terms-wrapper { 
        width: 90%;
    } 

    .terms-title { 
        font-size: 50px; 
        margin-bottom: 35px;
    }
}

/* macbook air */
/* 1280-800 */
@media (max-width:1280px) {
    .terms-title { 
        font-size: 48px;  
    }
}

/* 1200-1920 */
@media (max-width:1200px) {}

/*1134x712*/
@media(max-width:1134px) {
    .terms-title { 
        font-size: 46px;  
    }
}

/* tablets */

/* micro duo */
/*1114x705*/
@media(max-width:1114px) {
    .terms-wrapper { 
        width: 95%;
    } 

    .terms-title { 
        font-size: 44px;  
    }
}

/*1024-768*/
/* ipad pro */
/*1024-1366*/
@media (max-width:1024px) {}

/* ipad pro 2/3 */
/* 981x1024 */
@media (max-width:981px) {}

/* 962x601 */
@media(max-width: 962px) {
    .terms-title { 
        font-size: 42px;  
    }
}

/* 900x1600 */
@media(max-width: 900px) {}

/* galaxy fold */
/* 884 x 1104 */
@media(max-width: 884px) {}

/* ipad pro 2022 */
/*834-1136*/
@media(max-width: 834px) {}

/* ipad air 4 */
/* 820x1180 */
@media(max-width: 820px) {}

/* ipad 2020 */
/* 810x1080 */
@media(max-width: 810px) {}

/* galaxy tab 7 */
/* 800x1280 */
@media(max-width: 800px) {}

/*778-304*/
@media(max-width: 778px) {}

/*775*/
@media(max-width: 775px) {}

/* ipad air/mini */
/* 768x1024 */
@media(max-width: 768px) {
    .terms-title { 
        font-size: 40px;  
    }

    .terms-subtitle {
        font-size: 16px;
        margin-bottom: 5px;
    }

    .terms-sm-text {
        font-size: 14px;
        margin-bottom: 5px;
    }

    ul {
        font-size: 14px;
        margin-left: 25px;

        p {
            margin: 0 !important;
        }
    } 

    .term {
        margin-bottom: 30px;
    }
}

/*712-1138*/
@media(max-width:712px) {}

/* ipad air 2/3 */
/* 694-768 */
@media(max-width:694px) {
    .terms-title { 
        font-size: 38px;  
        text-align: center;
    }
}

/* ipad pro 1/2 */
/* 678-1024 */
@media(max-width:678px) {
    .terms-title { 
        font-size: 36px;   
    }
}

/* 600x962 */
@media(max-width:600px) {}

/* 577-951 */
@media(max-width:577px) {}

/* 540-960 */
@media(max-width:540px) {
    .terms-wrapper {
        padding: 10px 0;
    }

    .terms-title { 
        font-size: 34px;   
    }
}

/* mobiles */

/* s-note */
/*480-853*/
@media (max-width:480px) {
    .terms-title { 
        font-size: 32px;   
    }
}

/* ipad air 2/3 */
/*438-1024*/
@media(max-width:438px) {
    .terms-title { 
        font-size: 30px;
        margin-bottom: 30px;   
    }

    .terms-subtitle {
        font-size: 14px;
    }

    .terms-sm-text {
        font-size: 12px;
    }

    ul {
        font-size: 12px; 
    }
}

/* ip14 pro max */
/* 430x932 */
@media(max-width:430px) {}

/* ip13 pro max */
/* 428-926 */
@media (max-width:428px) {}

/* ip11 pro max */
/* 414-896/736*/
@media (max-width:414px) {}

/* s21 ultra, pix6 */
/* 412-915*/
/* heights: 732, 824, 846, 869, 892, 906, 915, 919 */
@media (max-width:412px) {}

/* ip14 pro, pix5 */
/*393 x 852*/
@media(max-width:393px) {}

/* ip13 pro */
/*390 x 844*/
@media(max-width:390px) {}

/* s21 plux */
/*384-854*/
@media(max-width:384px) {
    .terms-title { 
        font-size: 28px;    
    }
}

/* ip X */
/*375-812/667*/
@media(max-width:375px) {}

/* s22 ultra */
/*360x772*/
@media(max-width:360px) {}

/* ip SE */
/*320x568*/
@media(max-width:320px) {}
</style>
